import { useTranslation } from 'react-i18next';

export const ErrorComponent = () => {
  const { t } = useTranslation();
  return (
    <div className='h-[100dvh] w-[100dvw] flex flex-col gap-8 items-center justify-center'>
      <h1 className='text-2xl'>{t('errorComponent.title')}</h1>
    </div>
  );
};
